import { useEffect } from 'react';

const imageUrls = [
  '/assets/images/star-bg.webp',
  '/assets/images/animate-britania-logo.webp',
  '/assets/images/animate-milk-bikkis-logo.webp',
  '/assets/images/sign-up-head-text.webp',
  '/assets/images/kural-heading-bg.webp',
  '/assets/images/congrats.webp',
  '/assets/images/congrats-tamil.webp',
  '/assets/images/rays.webp',
  '/assets/images/cashback-star-element.webp',
  '/assets/images/voucher-text.webp',
  '/assets/images/voucher-text-tamil.webp',
  '/assets/images/button-bg.webp',
  '/assets/images/action-button-bg.webp',
];

const videoUrls = [
  '/assets/images/how-to-scan.mp4',
];

const scheduleIdle = window.requestIdleCallback || ((callback) => window.setTimeout(callback, 1));
const cancelIdle = window.cancelIdleCallback || window.clearTimeout;

function preloadImage(url) {
  return new Promise((resolve) => {
    const img = new Image();
    let resolved = false;

    const finish = (status) => {
      if (resolved) return;
      resolved = true;
      resolve(['images', url, status]);
    };

    img.onload = () => finish('loaded');
    img.onerror = () => finish('error');
    img.src = url;

    if (img.decode) {
      img.decode().then(
        () => finish('loaded'),
        () => undefined
      );
    }
  });
}

function preloadVideoMetadata(url) {
  return new Promise((resolve) => {
    const video = document.createElement('video');

    const finish = (status) => {
      video.remove();
      resolve(['videos', url, status]);
    };

    video.preload = 'metadata';
    video.muted = true;
    video.playsInline = true;
    video.onloadedmetadata = () => finish('loaded');
    video.onerror = () => finish('error');
    video.src = url;
    video.load();
  });
}

const AssetsPreloader = ({ onPreloadComplete }) => {
  useEffect(() => {
    let cancelled = false;

    const preload = async () => {
      const entries = await Promise.all([
        ...imageUrls.map(preloadImage),
        ...videoUrls.map(preloadVideoMetadata),
      ]);

      if (cancelled) return;

      const loadedStatus = { videos: {}, images: {} };
      entries.forEach(([type, url, status]) => {
        loadedStatus[type][url] = status;
      });

      if (onPreloadComplete) onPreloadComplete(loadedStatus);
    };

    const preloadHandle = scheduleIdle(preload);

    return () => {
      cancelled = true;
      cancelIdle(preloadHandle);
    };
  }, [onPreloadComplete]);

  return null;
};

export default AssetsPreloader;
